export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10281.08a062d1.jpg";